import React, { useEffect, useRef, useState } from "react";
import { CardUi } from "../../ui/CardUi";
import { Col, Form, Input, Row, Space, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { ButtonUi } from "../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { RutaDiv } from "./RutaDiv";
import { RutaDrawer } from "./drawer/RutaDrawer";
import { FormUi } from "../../ui/FormUi";
import {
  moduloClearActive,
  moduloUpdated,
  rutasModuloClearActive,
} from "../../../actions/usuario";
import { FormItemHiddenUi } from "../../ui/FormItemHiddenUi";
import { UploadOutlined } from "@ant-design/icons";
import { RutaUploadModal } from "./modal/RutaUploadModal";

const initialValues = {
  id: null,
  nombre: null,
  rutasmodulo: [],
};
const useResetFormOnClose = ({ form, open, activeModulo }) => {
  const dispatch = useDispatch();
  const prevOpenRef = useRef();
  useEffect(() => {
    prevOpenRef.current = open;
  }, [open]);
  const prevOpen = prevOpenRef.current;

  useEffect(() => {
    if (!open && prevOpen) {
      dispatch(moduloClearActive());
      form.resetFields();
    }
    if (open) {
      //Abrir Modal
      if (activeModulo)
        //entro editar
        form.setFieldsValue({ ...activeModulo });
    }
  }, [form, prevOpen, open]);
};
export const RutaScreen = ({ openForm, HandleCloseForm }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [keysSelected, setkeysSelected] = useState([]);
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const { activeModulo, rutasModulo } = useSelector((state) => state.usuario);
  useResetFormOnClose({ form, open: openForm, activeModulo });
  const [openDrawer, setOpenDrawer] = useState(false);
  const handleOpenDrawer = () => setOpenDrawer(true);
  const handleCloseDrawer = () => setOpenDrawer(false);
  const handleTreeNodeSelected = (keys) => setkeysSelected(keys);
  const handleTreeNodeClearSelected = () => setkeysSelected([]);
  const handleCloseFormScreen = () => {
    const valuesData = { ...activeModulo, rutasmodulo: rutasModulo };
    dispatch(moduloUpdated(valuesData));
    dispatch(rutasModuloClearActive());
    HandleCloseForm();
  };
  const handleOpenUploadModal = () => setOpenUploadModal(true);
  const handleCloseUploadModal = () => setOpenUploadModal(false);
  return (
    <>
      <CardUi
        title="Mantenimiento de ruta"
        size="small"
        extra={
          <Space className="site-button-ghost-wrapper" wrap>
            <Tooltip title="Salir">
              <ButtonUi
                typeUi={TipoButtonConstants.Cancelar}
                onClick={handleCloseFormScreen}
              />
            </Tooltip>
            <Tooltip title="Cargar rutas por json">
              {/* <RutasUpload /> */}
              <ButtonUi
                icon={<UploadOutlined />}
                color="cyan"
                variant="outlined"
                typeUi={TipoButtonConstants.CustomButton}
                text="Importar"
                onClick={handleOpenUploadModal}
              />
            </Tooltip>
          </Space>
        }
      >
        <FormUi
          name="FormRutaModulo"
          form={form}
          layout="vertical"
          autoComplete="off"
          initialValues={initialValues}
          hideRequiredMark
        >
          <FormItemHiddenUi name="rutasmodulo" />
          <Row gutter={[8, 8]}>
            <Col xs={24} sm={24} md={18} lg={18} xl={18}>
              <Form.Item name="nombre" label="Nombre">
                <Input variant="outlined" readOnly />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[8, 8]} style={{ marginTop: "8px" }}>
            <Col md={24} lg={20} xl={18} xxl={14}>
              <RutaDiv
                keysSelected={keysSelected}
                handleOpenDrawer={handleOpenDrawer}
                handleTreeNodeSelected={handleTreeNodeSelected}
              />
            </Col>
          </Row>
        </FormUi>
      </CardUi>
      <RutaDrawer
        open={openDrawer}
        handleCloseDrawer={handleCloseDrawer}
        handleTreeNodeClearSelected={handleTreeNodeClearSelected}
      />
      <RutaUploadModal
        open={openUploadModal}
        handleCloseModal={handleCloseUploadModal}
      />
    </>
  );
};
